import { useMemo } from 'react';

import { getTableOptions } from '../utils/tableOptions.ts';
import type { PluginConfig } from '@atlaskit/editor-plugin-table/types';

export const useTableOptions = (): PluginConfig => {
	return useMemo(() => getTableOptions(), []);
};
